export default __webpack_public_path__ + "static/watercooler-1626d2bbb84b65b00a58d5ac75ba5113.mp4";